var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3563 17.5125C49.2188 16.375 47.3813 16.375 46.2438 17.5125L29.7938 33.9625L33.9063 38.075L50.3563 21.5958C51.4646 20.4875 51.4646 18.6208 50.3563 17.5125ZM62.723 17.4833L33.9063 46.3L23.7563 36.1791C22.6188 35.0416 20.7813 35.0416 19.6438 36.1791C18.5063 37.3166 18.5063 39.1541 19.6438 40.2916L31.8355 52.4833C32.973 53.6208 34.8105 53.6208 35.948 52.4833L66.8355 21.625C67.973 20.4875 67.973 18.65 66.8355 17.5125H66.8063C65.698 16.3458 63.8605 16.3458 62.723 17.4833ZM3.16465 40.3208L15.3563 52.5125C16.4938 53.65 18.3313 53.65 19.4688 52.5125L21.5105 50.4708L7.27715 36.1791C6.13965 35.0416 4.30215 35.0416 3.16465 36.1791C2.02715 37.3166 2.02715 39.1833 3.16465 40.3208Z",
    fill: "#3BC35C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check-double.6fff456cb39eb04a788f6d62195a7acc.svg";
export { ForwardRef as ReactComponent };